module.exports = __webpack_public_path__ + "static/media/image52.1dfdd335.png";